import { number, string } from 'prop-types'

import { useHotspots } from '../../gate/hotspots-provider.js'
import Tooltip from './post-tooltip.js'
import keyPress from '../../../utilities/keyPress.js'

const Marker = (props) => {
  const { x, y, productId, index } = props
  const { activeProductId, setActiveProductId, activeProductName, handleOnClickProduct } =
    useHotspots()

  const isCurrentProduct = activeProductId === productId

  return (
    <div
      className="flbx-hotspot-marker"
      onBlur={() => setActiveProductId('')}
      onClick={(e) => handleOnClickProduct(e, index)}
      onFocus={() => {
        setActiveProductId(productId)
      }}
      onKeyDown={(e) => {
        keyPress(e, () => handleOnClickProduct(e, index))
      }}
      onMouseEnter={() => {
        setActiveProductId(productId)
        // Set timeout because otherwise, when we do the mouseEnter, the tooltip is not yet created
      }}
      onMouseLeave={() => setActiveProductId('')}
      role="link"
      style={{
        left: `${x * 100}%`,
        top: `${y * 100}%`,
      }}
      tabIndex={0}
    >
      <Tooltip content={activeProductName} open={isCurrentProduct} x={x} y={y}>
        <div
          className={`${
            isCurrentProduct ? 'flbx-hotspot-current' : 'flbx-hotspot-not-current'
          } flbx-hotspot`}
        >
          <div>{index}</div>
        </div>
      </Tooltip>
    </div>
  )
}

Marker.propTypes = {
  index: number.isRequired,
  productId: string.isRequired,
  x: number.isRequired,
  y: number.isRequired,
}

export default Marker
